import { render, staticRenderFns } from "./StructureTree.vue?vue&type=template&id=2280c2b7"
import script from "./StructureTree.vue?vue&type=script&lang=js"
export * from "./StructureTree.vue?vue&type=script&lang=js"
import style0 from "./StructureTree.vue?vue&type=style&index=0&id=2280c2b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports